const Template = `<div>
<div  class="left-menu">
	<b-form-input class='input-dark' v-model="filter" :placeholder="$t('general.search')"></b-form-input>
  
<div  class="left-menu-table">

    <b-table
      id="left-table"
      :filter="filter"
      :items="users"
      :per-page="perPage"
      :current-page="currentPage"
      :fields="fields"
      :tbody-tr-class="rowClass"

      striped
      borderless
      
      small
      hover
      dark
  		@row-clicked="userListClick"
    >
        
 	  	
    </b-table>
  </div>

      <b-pagination
      v-model="currentPage"
      :total-rows="menuRows"
      :per-page="perPage"
      aria-controls="left-table"
            first-text="⏮"
      prev-text="⏪"
      next-text="⏩"
      last-text="⏭"
    ></b-pagination>
  </div>    
</div>`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page3_users/left_menu/template.js